export default "__VITE_ASSET__C$ENSMgB__"